module.exports = __webpack_public_path__ + "img/cp-passwordcard.d9ecb29e.jpg";